import { render, staticRenderFns } from "./AddChangePassword.vue?vue&type=template&id=c14d8d7c&"
import script from "./AddChangePassword.vue?vue&type=script&lang=js&"
export * from "./AddChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./AddChangePassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports